import { transformWithSpec } from "../../../utils/response.js";
function promoInfoEndpoints(builder) {
  return {
    getPromoInfo: builder.query({
      providesTags: ["promo-info"],
      query: () => "/member/promo-info",
      transformResponse: transformWithSpec()
    })
  };
}
export {
  promoInfoEndpoints as default
};
